/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * metapic-api
 * Metapic API
 * OpenAPI spec version: 0.0.1
 */
import * as axios from 'axios'
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'

import type {
  GetCampaignParticipantCountByClickActivity200,
  GetCampaignParticipantCountByClickActivityParams,
  GetCampaignParticipantStats200,
  GetCampaignParticipantStatsParams,
  ListCampaignParticipants200,
  ListCampaignParticipantsParams,
  OfferParticipantResource,
  OfferUserResource,
  OverrideClickLimitRequest,
  OverrideCostsRequest,
  UpdateParticipantPaymentAmountRequest,
  UpdateParticipantStatusRequest,
  UpdateParticipantTodoRequest,
} from '../metapicApi.schemas'

export const getCampaignParticipant = (axiosInstance: AxiosInstance = axios.default) => {
  /**
   * @summary Checks if user has been added to the offer
   */
  const offersUsersShow = (
    offer: number,
    user: number,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<OfferUserResource>> => {
    return axiosInstance.get(`/v2/offers/${offer}/users/${user}`, options)
  }
  /**
   * @summary List participants in a campaign
   */
  const listCampaignParticipants = (
    offer: number,
    params?: ListCampaignParticipantsParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<ListCampaignParticipants200>> => {
    return axiosInstance.get(`/v2/offers/${offer}/participants`, {
      ...options,
      params: { ...params, ...options?.params },
    })
  }
  /**
   * @summary Store a newly created resource in storage
   */
  const offersParticipantsStore = (
    offer: string,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(`/v2/offers/${offer}/participants`, undefined, options)
  }
  /**
   * @summary Get participant details
   */
  const getCampaignParticipant = (
    offer: number,
    participant: number,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<OfferParticipantResource>> => {
    return axiosInstance.get(`/v2/offers/${offer}/participants/${participant}`, options)
  }
  /**
   * @summary Update the specified resource in storage
   */
  const offersParticipantsUpdate = (
    id: string,
    participant: string,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<void>> => {
    return axiosInstance.put(`/v2/offers/${id}/participants/${participant}`, undefined, options)
  }
  /**
   * @summary Remove the specified resource from storage
   */
  const offersParticipantsDestroy = (
    id: string,
    participant: string,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<void>> => {
    return axiosInstance.delete(`/v2/offers/${id}/participants/${participant}`, options)
  }
  /**
   * @summary Retrieve participants statistics for a campaign
   */
  const getCampaignParticipantStats = (
    offer: number,
    params: GetCampaignParticipantStatsParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<GetCampaignParticipantStats200>> => {
    return axiosInstance.get(`/v2/offers/${offer}/participants-stats`, {
      ...options,
      params: { ...params, ...options?.params },
    })
  }
  /**
   * @summary Retrieve participants count by active/inactive
   */
  const getCampaignParticipantCountByClickActivity = (
    offer: number,
    params: GetCampaignParticipantCountByClickActivityParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<GetCampaignParticipantCountByClickActivity200>> => {
    return axiosInstance.get(`/v2/offers/${offer}/participants-count-by-click-activity`, {
      ...options,
      params: { ...params, ...options?.params },
    })
  }
  /**
   * @summary Update participant status
   */
  const updateCampaignParticipantStatus = (
    offer: number,
    participant: number,
    updateParticipantStatusRequest: UpdateParticipantStatusRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<OfferParticipantResource>> => {
    return axiosInstance.patch(
      `/v2/offers/${offer}/participants/${participant}/update-status`,
      updateParticipantStatusRequest,
      options,
    )
  }
  /**
   * @summary Update participant todo
   */
  const updateCampaignParticipantTodo = (
    offer: number,
    participant: number,
    updateParticipantTodoRequest: UpdateParticipantTodoRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<OfferParticipantResource>> => {
    return axiosInstance.patch(
      `/v2/offers/${offer}/participants/${participant}/todo`,
      updateParticipantTodoRequest,
      options,
    )
  }
  /**
   * @summary Update participant payment amount
   */
  const updateCampaignParticipantPaymentAmount = (
    offer: number,
    participant: number,
    updateParticipantPaymentAmountRequest: UpdateParticipantPaymentAmountRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<OfferParticipantResource>> => {
    return axiosInstance.put(
      `/v2/offers/${offer}/participants/${participant}/payment-amount`,
      updateParticipantPaymentAmountRequest,
      options,
    )
  }
  /**
   * @summary Set/override click limit
   */
  const updateCampaignParticipantOverrideClickLimit = (
    offer: number,
    participant: number,
    overrideClickLimitRequest: OverrideClickLimitRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<OfferParticipantResource>> => {
    return axiosInstance.patch(
      `/v2/offers/${offer}/participants/${participant}/overrides/clicks`,
      overrideClickLimitRequest,
      options,
    )
  }
  /**
   * @summary Override campaign's costs
   */
  const updateCampaignParticipantOverrideCosts = (
    offer: number,
    participant: number,
    overrideCostsRequest: OverrideCostsRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<OfferParticipantResource>> => {
    return axiosInstance.patch(
      `/v2/offers/${offer}/participants/${participant}/overrides/costs`,
      overrideCostsRequest,
      options,
    )
  }
  /**
   * @summary Checks if user has been added to the offer
   */
  const campaignCampaignParticipantOfferUserShow0 = (
    offer: string,
    user: number,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<OfferUserResource>> => {
    return axiosInstance.get(`/v2/offer-by-token/${offer}/users/${user}`, options)
  }
  /**
   * This can only be performed by the user themselves.
   * @summary Mark user as having joined the campaign
   */
  const offerUserJoin = (
    offer: string,
    user: number,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<string>> => {
    return axiosInstance.post(`/v2/offer-by-token/${offer}/users/${user}/join`, undefined, {
      ...options,
    })
  }
  return {
    offersUsersShow,
    listCampaignParticipants,
    offersParticipantsStore,
    getCampaignParticipant,
    offersParticipantsUpdate,
    offersParticipantsDestroy,
    getCampaignParticipantStats,
    getCampaignParticipantCountByClickActivity,
    updateCampaignParticipantStatus,
    updateCampaignParticipantTodo,
    updateCampaignParticipantPaymentAmount,
    updateCampaignParticipantOverrideClickLimit,
    updateCampaignParticipantOverrideCosts,
    campaignCampaignParticipantOfferUserShow0,
    offerUserJoin,
  }
}
export type OffersUsersShowResult = AxiosResponse<OfferUserResource>
export type ListCampaignParticipantsResult = AxiosResponse<ListCampaignParticipants200>
export type OffersParticipantsStoreResult = AxiosResponse<void>
export type GetCampaignParticipantResult = AxiosResponse<OfferParticipantResource>
export type OffersParticipantsUpdateResult = AxiosResponse<void>
export type OffersParticipantsDestroyResult = AxiosResponse<void>
export type GetCampaignParticipantStatsResult = AxiosResponse<GetCampaignParticipantStats200>
export type GetCampaignParticipantCountByClickActivityResult =
  AxiosResponse<GetCampaignParticipantCountByClickActivity200>
export type UpdateCampaignParticipantStatusResult = AxiosResponse<OfferParticipantResource>
export type UpdateCampaignParticipantTodoResult = AxiosResponse<OfferParticipantResource>
export type UpdateCampaignParticipantPaymentAmountResult = AxiosResponse<OfferParticipantResource>
export type UpdateCampaignParticipantOverrideClickLimitResult =
  AxiosResponse<OfferParticipantResource>
export type UpdateCampaignParticipantOverrideCostsResult = AxiosResponse<OfferParticipantResource>
export type CampaignCampaignParticipantOfferUserShow0Result = AxiosResponse<OfferUserResource>
export type OfferUserJoinResult = AxiosResponse<string>
